import React from 'react'
import type { Question } from '@pbt/pbt-ui-components'

import QuestionsListWidgetLockedItem from './QuestionsListWidgetLockedItem'

const QuestionsListWidgetLockedFollowUpItem = ({
  question,
}: {
  question: Question
}) => {
  const followUps =
    question.answers?.reduce((selectedFollowUps: Question[], current) => {
      const { followUpQuestion, selected } = current
      if (followUpQuestion && selected) {
        return [...selectedFollowUps, followUpQuestion]
      }
      return selectedFollowUps
    }, []) || []

  return (
    <>
      <QuestionsListWidgetLockedItem question={question} />
      {followUps.map((followUpQuestion) => (
        <QuestionsListWidgetLockedItem
          key={followUpQuestion.id}
          paddingLeft={2}
          question={followUpQuestion}
        />
      ))}
    </>
  )
}

export default QuestionsListWidgetLockedFollowUpItem
